export default __webpack_public_path__ + "static/media/cone_black.a9baf70b.svg";